import React from "react";
import * as S from "./styles";

import { usePolicemanRegister } from "contexts/register/PolicemanContext";

import { IAddressProps } from "interfaces/Address";

import Input from "../../../Input";
import MaskedInput from "../../../MaskedInput";

function AddressForm({ updateAddressData }: any) {
  const {
    address,
    setAddress,
    addressByPostalCode,
    errors,
    addError,
    removeError,
    searchingPostalCode,
  } = usePolicemanRegister();

  function changeValue(value: string, key: keyof IAddressProps) {
    setAddress((_address) => {
      _address[key] = value as never;

      return _address;
    });
  }

  function validateCity(event: React.ChangeEvent<HTMLInputElement>) {
    const city = event.target.value;

    if (city.length < 2) {
      addError("city", "Cidade inválida");

      return;
    }

    removeError("city");
  }

  return (
    <S.Wrapper>
      {searchingPostalCode && (
        <S.LoadingWrapper>
          <span>Pesquisando dados do CEP...</span>
        </S.LoadingWrapper>
      )}

      {!searchingPostalCode && (
        <S.Form>
          <MaskedInput
            id="cep"
            label="CEP"
            name="cep"
            defaultValue={
              address.postalCode
                ? address.postalCode
                : updateAddressData?.postalCode
            }
            mask="99999-999"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              changeValue(event.target.value, "postalCode");

              addressByPostalCode(event.target.value);
            }}
            required
            error={errors.postalCode || errors["address.postalCode"]}
            apiErrorName="address.postalCode"
            handleApiErrorRemove={() => removeError("address.postalCode")}
          />
          <S.DocumentContainer>
            <Input
              id="street"
              name="street"
              key="inputStreet"
              defaultValue={
                address.street ? address.street : updateAddressData?.street
              }
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                changeValue(event.target.value, "street");
              }}
              label="Logradouro"
              required={true}
              type="text"
              error={errors.street || errors["address.street"]}
              apiErrorName="address.street"
              handleApiErrorRemove={() => removeError("address.street")}
            />

            <Input
              id="Number"
              defaultValue={
                address.number ? address.number : updateAddressData?.number
              }
              name="Number"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                changeValue(event.target.value, "number");
              }}
              label="Número"
              required={true}
              type="text"
              error={errors.number || errors["address.number"]}
              apiErrorName="address.number"
              handleApiErrorRemove={() => removeError("address.number")}
            />
          </S.DocumentContainer>
          <Input
            id="district"
            name="district"
            defaultValue={
              address.district ? address.district : updateAddressData?.district
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              changeValue(event.target.value, "district");
            }}
            label="Bairro"
            required={true}
            type="text"
            error={errors.district || errors["address.district"]}
            apiErrorName="address.district"
            handleApiErrorRemove={() => removeError("address.district")}
          />
          <S.DocumentContainer>
            <Input
              id="uf"
              name="uf"
              defaultValue={address.uf ? address.uf : updateAddressData?.uf}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                changeValue(event.target.value, "uf");
              }}
              label="UF"
              required={true}
              type="text"
              maxLength={2}
              error={errors.uf || errors["address.uf"]}
              apiErrorName="address.uf"
              handleApiErrorRemove={() => removeError("address.uf")}
            />
            <Input
              id="city"
              name="city"
              onBlur={validateCity}
              defaultValue={
                address.city ? address.city : updateAddressData?.city
              }
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                changeValue(event.target.value, "city");
              }}
              label="Cidade"
              required={true}
              type="text"
              error={errors.city || errors["address.city"]}
              apiErrorName="address.city"
              handleApiErrorRemove={() => removeError("address.city")}
            />
          </S.DocumentContainer>
          <Input
            id="reference"
            name="reference"
            defaultValue={
              address.reference
                ? address.reference
                : updateAddressData?.reference
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              changeValue(event.target.value, "reference");
            }}
            label="Referência"
            required={true}
            type="text"
            error={errors.reference || errors["address.reference"]}
            apiErrorName="address.reference"
            handleApiErrorRemove={() => removeError("address.reference")}
          />
          <Input
            id="complement"
            name="complement"
            defaultValue={
              address.complement
                ? address.complement
                : updateAddressData?.complement
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              changeValue(event.target.value, "complement");
            }}
            label="Complemento"
            required={false}
            type="text"
            error={errors.complement || errors["address.complement"]}
            apiErrorName="address.complement"
            handleApiErrorRemove={() => removeError("address.complement")}
          />
        </S.Form>
      )}
    </S.Wrapper>
  );
}

export { AddressForm };
